// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"fffc6b41","107":"413e3a52","982":"4ed33f21"}[chunkId] + ".chunk.js";
};